module.exports = __webpack_public_path__ + "img/leodagan.99232927.gif";